import { render, staticRenderFns } from "./PFormInputTextSearch.vue?vue&type=template&id=4ae878ee&scoped=true&"
import script from "./PFormInputTextSearch.vue?vue&type=script&lang=ts&"
export * from "./PFormInputTextSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputTextSearch.vue?vue&type=style&index=0&id=4ae878ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae878ee",
  null
  
)

export default component.exports